export default () => {
  const momentumVelocity = 0.8;

  document.querySelectorAll('.image-scroll').forEach(async (imageScroll) => {
    const scroll = imageScroll.querySelector('.image-scroll__scroll');
    const img = imageScroll.querySelector('img');

    if (!img) return;

    const initialTopPercent = parseInt(scroll.getAttribute('data-top')) || 50;
    const initialLeftPercent = parseInt(scroll.getAttribute('data-left')) || 50;
    imageScroll.classList.add('initialized');

    await new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          resolve();
        });
      });
    });

    scroll.scrollTop = ( scroll.scrollHeight - scroll.offsetHeight ) / 100 * initialTopPercent;
    scroll.scrollLeft = ( scroll.scrollWidth - scroll.offsetWidth ) / 100 * initialLeftPercent;

    const slider = scroll;
    let isDown = false;
    let startX;
    let startY;
    let scrollLeft;
    let scrollTop;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      startY = e.pageY - slider.offsetTop;
      scrollLeft = slider.scrollLeft;
      scrollTop = slider.scrollTop;
      cancelMomentumTracking();
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      beginMomentumTracking();
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const y = e.pageY - slider.offsetTop;
      const walkX = (x - startX) * 3; //scroll-fast
      const walkY = (y - startY) * 3; //scroll-fast
      let prevScrollLeft = slider.scrollLeft;
      let prevScrollTop = slider.scrollTop;
      slider.scrollLeft = scrollLeft - walkX;
      slider.scrollTop = scrollTop - walkY;
      velX = slider.scrollLeft - prevScrollLeft;
      velY = slider.scrollTop - prevScrollTop;
    });

    // Momentum
    let velX = 0;
    let velY = 0;
    let momentumID;

    slider.addEventListener('wheel', (e) => {
      cancelMomentumTracking();
    });

    function beginMomentumTracking() {
      cancelMomentumTracking();
      momentumID = requestAnimationFrame(momentumLoop);
    }
    function cancelMomentumTracking() {
      cancelAnimationFrame(momentumID);
    }
    function momentumLoop() {
      slider.scrollLeft += velX;
      slider.scrollTop += velY;
      velX *= momentumVelocity;
      velY *= momentumVelocity;
      if (Math.abs(velX) > 0.5 || Math.abs(velY) > 0.5) {
        momentumID = requestAnimationFrame(momentumLoop);
      }
    }
  });
};
